var map = {
	"./consume-record.svg": "9Dzw",
	"./dashboard.svg": "BCGP",
	"./data-history.svg": "lb2f",
	"./data-query.svg": "VioT",
	"./data.svg": "RUrO",
	"./document.svg": "mDNq",
	"./entrance-guidance.svg": "KeFE",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./flow-analysis.svg": "1f6l",
	"./flow-report.svg": "548A",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./password.svg": "QjmH",
	"./report-query.svg": "cFkH",
	"./risk-query.svg": "0SDS",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./video.svg": "3JNx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 36